export interface TrackType {
  name: string
  garmin_id: string
  category: string
  category_name: string
}

export interface TrackTypeCategory {
  [key: string]: TrackType
}

export interface TrackTypeData {
  [categoryName: string]: TrackTypeCategory
}

export const toursTrackType: TrackTypeData = {
  Cycling: {
    bmx: {
      name: 'BMX',
      garmin_id: 'bmx',
      category: 'cycling',
      category_name: 'Cycling',
    },
    cyclocross: {
      name: 'Cyclocross',
      garmin_id: 'cyclocross',
      category: 'cycling',
      category_name: 'Cycling',
    },
    downhill_mountain_biking: {
      name: 'Downhill Mountain Biking',
      garmin_id: 'downhill_mountain_biking',
      category: 'cycling',
      category_name: 'Cycling',
    },
    ebiking: {
      name: 'eBiking',
      garmin_id: 'ebiking',
      category: 'cycling',
      category_name: 'Cycling',
    },
    eenduro_mountain_biking: {
      name: 'eEnduro Mountain Biking',
      garmin_id: 'eenduro_mountain_biking',
      category: 'cycling',
      category_name: 'Cycling',
    },
    emountain_biking: {
      name: 'eMountain Biking',
      garmin_id: 'emountain_biking',
      category: 'cycling',
      category_name: 'Cycling',
    },
    enduro_mountain_biking: {
      name: 'Enduro Mountain Biking',
      garmin_id: 'enduro_mountain_biking',
      category: 'cycling',
      category_name: 'Cycling',
    },
    gravel_cycling: {
      name: 'Gravel Cycling',
      garmin_id: 'gravel_cycling',
      category: 'cycling',
      category_name: 'Cycling',
    },
    handcycling: {
      name: 'Handcycling',
      garmin_id: 'handcycling',
      category: 'cycling',
      category_name: 'Cycling',
    },
    indoor_cycling: {
      name: 'Indoor Cycling',
      garmin_id: 'indoor_cycling',
      category: 'cycling',
      category_name: 'Cycling',
    },
    indoor_handcycling: {
      name: 'Indoor Handcycling',
      garmin_id: 'indoor_handcycling',
      category: 'cycling',
      category_name: 'Cycling',
    },
    mountain_biking: {
      name: 'Mountain Biking',
      garmin_id: 'mountain_biking',
      category: 'cycling',
      category_name: 'Cycling',
    },
    recumbent_cycling: {
      name: 'Recumbent Cycling',
      garmin_id: 'recumbent_cycling',
      category: 'cycling',
      category_name: 'Cycling',
    },
    road_biking: {
      name: 'Road Cycling',
      garmin_id: 'road_biking',
      category: 'cycling',
      category_name: 'Cycling',
    },
    track_cycling: {
      name: 'Track Cycling',
      garmin_id: 'track_cycling',
      category: 'cycling',
      category_name: 'Cycling',
    },
    virtual_cycling: {
      name: 'Virtual Cycling',
      garmin_id: 'virtual_cycling',
      category: 'cycling',
      category_name: 'Cycling',
    },
  },
  Hiking: {
    hiking: {
      name: 'Hiking',
      garmin_id: 'hiking',
      category: 'hiking',
      category_name: 'Hiking',
    },
    rucking: {
      name: 'Rucking',
      garmin_id: 'rucking',
      category: 'hiking',
      category_name: 'Hiking',
    },
  },
  Running: {
    indoor_running: {
      name: 'Indoor Running',
      garmin_id: 'indoor_running',
      category: 'running',
      category_name: 'Running',
    },
    obstacle_course_racing: {
      name: 'Obstacle Course Racing',
      garmin_id: 'obstacle_course_racing',
      category: 'running',
      category_name: 'Running',
    },
    street_running: {
      name: 'Street Running',
      garmin_id: 'street_running',
      category: 'running',
      category_name: 'Running',
    },
    track_running: {
      name: 'Track Running',
      garmin_id: 'track_running',
      category: 'running',
      category_name: 'Running',
    },
    trail_running: {
      name: 'Trail Running',
      garmin_id: 'trail_running',
      category: 'running',
      category_name: 'Running',
    },
    treadmill_running: {
      name: 'Treadmill Running',
      garmin_id: 'treadmill_running',
      category: 'running',
      category_name: 'Running',
    },
    ultra_running: {
      name: 'Ultra Running',
      garmin_id: 'ultra_running',
      category: 'running',
      category_name: 'Running',
    },
    virtual_running: {
      name: 'Virtual Running',
      garmin_id: 'virtual_running',
      category: 'running',
      category_name: 'Running',
    },
  },
  'Gym & Fitness Equipment': {
    bouldering: {
      name: 'Bouldering',
      garmin_id: 'bouldering',
      category: 'gym_fitness_equipment',
      category_name: 'Gym & Fitness Equipment',
    },
    cardio: {
      name: 'Cardio',
      garmin_id: 'cardio',
      category: 'gym_fitness_equipment',
      category_name: 'Gym & Fitness Equipment',
    },
    dance_fitness: {
      name: 'Dance Fitness',
      garmin_id: 'dance_fitness',
      category: 'gym_fitness_equipment',
      category_name: 'Gym & Fitness Equipment',
    },
    elliptical: {
      name: 'Elliptical',
      garmin_id: 'elliptical',
      category: 'gym_fitness_equipment',
      category_name: 'Gym & Fitness Equipment',
    },
    hiit: {
      name: 'HIIT',
      garmin_id: 'hiit',
      category: 'gym_fitness_equipment',
      category_name: 'Gym & Fitness Equipment',
    },
    indoor_climbing: {
      name: 'Indoor Climbing',
      garmin_id: 'indoor_climbing',
      category: 'gym_fitness_equipment',
      category_name: 'Gym & Fitness Equipment',
    },
    indoor_rowing: {
      name: 'Indoor Rowing',
      garmin_id: 'indoor_rowing',
      category: 'gym_fitness_equipment',
      category_name: 'Gym & Fitness Equipment',
    },
    jump_rope: {
      name: 'Jump Rope',
      garmin_id: 'jump_rope',
      category: 'gym_fitness_equipment',
      category_name: 'Gym & Fitness Equipment',
    },
    mobility: {
      name: 'Mobility',
      garmin_id: 'mobility',
      category: 'gym_fitness_equipment',
      category_name: 'Gym & Fitness Equipment',
    },
    onshore_grinding: {
      name: 'Onshore Grinding',
      garmin_id: 'onshore_grinding',
      category: 'gym_fitness_equipment',
      category_name: 'Gym & Fitness Equipment',
    },
    pilates: {
      name: 'Pilates',
      garmin_id: 'pilates',
      category: 'gym_fitness_equipment',
      category_name: 'Gym & Fitness Equipment',
    },
    stair_stepper: {
      name: 'Stair Stepper',
      garmin_id: 'stair_stepper',
      category: 'gym_fitness_equipment',
      category_name: 'Gym & Fitness Equipment',
    },
    strength_training: {
      name: 'Strength Training',
      garmin_id: 'strength_training',
      category: 'gym_fitness_equipment',
      category_name: 'Gym & Fitness Equipment',
    },
    yoga: {
      name: 'Yoga',
      garmin_id: 'yoga',
      category: 'gym_fitness_equipment',
      category_name: 'Gym & Fitness Equipment',
    },
  },
  Diving: {
    apnea: {
      name: 'Apnea',
      garmin_id: 'apnea',
      category: 'diving',
      category_name: 'Diving',
    },
    apnea_hunt: {
      name: 'Apnea Hunt',
      garmin_id: 'apnea_hunt',
      category: 'diving',
      category_name: 'Diving',
    },
    ccr_dive: {
      name: 'CCR Dive',
      garmin_id: 'ccr_dive',
      category: 'diving',
      category_name: 'Diving',
    },
    gauge_dive: {
      name: 'Gauge Dive',
      garmin_id: 'gauge_dive',
      category: 'diving',
      category_name: 'Diving',
    },
    'multi-gas_dive': {
      name: 'Multi-Gas Dive',
      garmin_id: 'multi-gas_dive',
      category: 'diving',
      category_name: 'Diving',
    },
    pool_apnea: {
      name: 'Pool Apnea',
      garmin_id: 'pool_apnea',
      category: 'diving',
      category_name: 'Diving',
    },
    'single-gas_dive': {
      name: 'Single-Gas Dive',
      garmin_id: 'single-gas_dive',
      category: 'diving',
      category_name: 'Diving',
    },
  },
  Other: {
    archery: {
      name: 'Archery',
      garmin_id: 'archery',
      category: 'other',
      category_name: 'Other',
    },
    atv: {
      name: 'ATV',
      garmin_id: 'atv',
      category: 'other',
      category_name: 'Other',
    },
    auto_racing: {
      name: 'Auto Racing',
      garmin_id: 'auto_racing',
      category: 'other',
      category_name: 'Other',
    },
    bike_to_run_transition: {
      name: 'Bike to Run Transition',
      garmin_id: 'bike_to_run_transition',
      category: 'other',
      category_name: 'Other',
    },
    boxing: {
      name: 'Boxing',
      garmin_id: 'boxing',
      category: 'other',
      category_name: 'Other',
    },
    breathwork: {
      name: 'Breathwork',
      garmin_id: 'breathwork',
      category: 'other',
      category_name: 'Other',
    },
    disc_golf: {
      name: 'Disc Golf',
      garmin_id: 'disc_golf',
      category: 'other',
      category_name: 'Other',
    },
    driving: {
      name: 'Driving',
      garmin_id: 'driving',
      category: 'other',
      category_name: 'Other',
    },
    floor_climbing: {
      name: 'Floor Climbing',
      garmin_id: 'floor_climbing',
      category: 'other',
      category_name: 'Other',
    },
    flying: {
      name: 'Flying',
      garmin_id: 'flying',
      category: 'other',
      category_name: 'Other',
    },
    gaming: {
      name: 'Gaming',
      garmin_id: 'gaming',
      category: 'other',
      category_name: 'Other',
    },
    golf: {
      name: 'Golf',
      garmin_id: 'golf',
      category: 'other',
      category_name: 'Other',
    },
    hang_gliding: {
      name: 'Hang Gliding',
      garmin_id: 'hang_gliding',
      category: 'other',
      category_name: 'Other',
    },
    horseback_riding: {
      name: 'Horseback Riding',
      garmin_id: 'horseback_riding',
      category: 'other',
      category_name: 'Other',
    },
    hunting: {
      name: 'Hunting',
      garmin_id: 'hunting',
      category: 'other',
      category_name: 'Other',
    },
    'hunting/fishing': {
      name: 'Hunting/Fishing',
      garmin_id: 'hunting/fishing',
      category: 'other',
      category_name: 'Other',
    },
    inline_skating: {
      name: 'Inline Skating',
      garmin_id: 'inline_skating',
      category: 'other',
      category_name: 'Other',
    },
    meditation: {
      name: 'Meditation',
      garmin_id: 'meditation',
      category: 'other',
      category_name: 'Other',
    },
    mixed_martial_arts: {
      name: 'Mixed Martial Arts',
      garmin_id: 'mixed_martial_arts',
      category: 'other',
      category_name: 'Other',
    },
    motocross: {
      name: 'Motocross',
      garmin_id: 'motocross',
      category: 'other',
      category_name: 'Other',
    },
    motorcycling: {
      name: 'Motorcycling',
      garmin_id: 'motorcycling',
      category: 'other',
      category_name: 'Other',
    },
    mountaineering: {
      name: 'Mountaineering',
      garmin_id: 'mountaineering',
      category: 'other',
      category_name: 'Other',
    },
    overland: {
      name: 'Overland',
      garmin_id: 'overland',
      category: 'other',
      category_name: 'Other',
    },
    'rc/drone': {
      name: 'RC/Drone',
      garmin_id: 'rc/drone',
      category: 'other',
      category_name: 'Other',
    },
    rock_climbing: {
      name: 'Rock Climbing',
      garmin_id: 'rock_climbing',
      category: 'other',
      category_name: 'Other',
    },
    run_to_bike_transition: {
      name: 'Run to Bike Transition',
      garmin_id: 'run_to_bike_transition',
      category: 'other',
      category_name: 'Other',
    },
    sky_diving: {
      name: 'Sky Diving',
      garmin_id: 'sky_diving',
      category: 'other',
      category_name: 'Other',
    },
    stopwatch: {
      name: 'Stopwatch',
      garmin_id: 'stopwatch',
      category: 'other',
      category_name: 'Other',
    },
    swim_to_bike_transition: {
      name: 'Swim to Bike Transition',
      garmin_id: 'swim_to_bike_transition',
      category: 'other',
      category_name: 'Other',
    },
    transition: {
      name: 'Transition',
      garmin_id: 'transition',
      category: 'other',
      category_name: 'Other',
    },
    'whitewater_kayaking/rafting': {
      name: 'Whitewater Kayaking/Rafting',
      garmin_id: 'whitewater_kayaking/rafting',
      category: 'other',
      category_name: 'Other',
    },
    'wind/kite_surfing': {
      name: 'Wind/Kite Surfing',
      garmin_id: 'wind/kite_surfing',
      category: 'other',
      category_name: 'Other',
    },
    wingsuit_flying: {
      name: 'Wingsuit Flying',
      garmin_id: 'wingsuit_flying',
      category: 'other',
      category_name: 'Other',
    },
  },
  Parasports: {
    'pushing_-_run_speed': {
      name: 'Pushing - Run Speed',
      garmin_id: 'pushing_-_run_speed',
      category: 'parasports',
      category_name: 'Parasports',
    },
    'pushing_-_walk_speed': {
      name: 'Pushing - Walk Speed',
      garmin_id: 'pushing_-_walk_speed',
      category: 'parasports',
      category_name: 'Parasports',
    },
  },
  'Racket Sports': {
    badminton: {
      name: 'Badminton',
      garmin_id: 'badminton',
      category: 'racket_sports',
      category_name: 'Racket Sports',
    },
    padel: {
      name: 'Padel',
      garmin_id: 'padel',
      category: 'racket_sports',
      category_name: 'Racket Sports',
    },
    pickleball: {
      name: 'Pickleball',
      garmin_id: 'pickleball',
      category: 'racket_sports',
      category_name: 'Racket Sports',
    },
    platform_tennis: {
      name: 'Platform Tennis',
      garmin_id: 'platform_tennis',
      category: 'racket_sports',
      category_name: 'Racket Sports',
    },
    racquetball: {
      name: 'Racquetball',
      garmin_id: 'racquetball',
      category: 'racket_sports',
      category_name: 'Racket Sports',
    },
    squash: {
      name: 'Squash',
      garmin_id: 'squash',
      category: 'racket_sports',
      category_name: 'Racket Sports',
    },
    table_tennis: {
      name: 'Table Tennis',
      garmin_id: 'table_tennis',
      category: 'racket_sports',
      category_name: 'Racket Sports',
    },
    tennis: {
      name: 'Tennis',
      garmin_id: 'tennis',
      category: 'racket_sports',
      category_name: 'Racket Sports',
    },
  },
  Swimming: {
    open_water_swimming: {
      name: 'Open Water Swimming',
      garmin_id: 'open_water_swimming',
      category: 'swimming',
      category_name: 'Swimming',
    },
    pool_swim: {
      name: 'Pool Swim',
      garmin_id: 'pool_swim',
      category: 'swimming',
      category_name: 'Swimming',
    },
  },
  'Team Sports': {
    american_football: {
      name: 'American Football',
      garmin_id: 'american_football',
      category: 'team_sports',
      category_name: 'Team Sports',
    },
    baseball: {
      name: 'Baseball',
      garmin_id: 'baseball',
      category: 'team_sports',
      category_name: 'Team Sports',
    },
    basketball: {
      name: 'Basketball',
      garmin_id: 'basketball',
      category: 'team_sports',
      category_name: 'Team Sports',
    },
    cricket: {
      name: 'Cricket',
      garmin_id: 'cricket',
      category: 'team_sports',
      category_name: 'Team Sports',
    },
    field_hockey: {
      name: 'Field Hockey',
      garmin_id: 'field_hockey',
      category: 'team_sports',
      category_name: 'Team Sports',
    },
    ice_hockey: {
      name: 'Ice Hockey',
      garmin_id: 'ice_hockey',
      category: 'team_sports',
      category_name: 'Team Sports',
    },
    lacrosse: {
      name: 'Lacrosse',
      garmin_id: 'lacrosse',
      category: 'team_sports',
      category_name: 'Team Sports',
    },
    rugby: {
      name: 'Rugby',
      garmin_id: 'rugby',
      category: 'team_sports',
      category_name: 'Team Sports',
    },
    'soccer/football': {
      name: 'Soccer/Football',
      garmin_id: 'soccer/football',
      category: 'team_sports',
      category_name: 'Team Sports',
    },
    softball: {
      name: 'Softball',
      garmin_id: 'softball',
      category: 'team_sports',
      category_name: 'Team Sports',
    },
    ultimate_disc: {
      name: 'Ultimate Disc',
      garmin_id: 'ultimate_disc',
      category: 'team_sports',
      category_name: 'Team Sports',
    },
    volleyball: {
      name: 'Volleyball',
      garmin_id: 'volleyball',
      category: 'team_sports',
      category_name: 'Team Sports',
    },
  },
  Walking: {
    casual_walking: {
      name: 'Casual Walking',
      garmin_id: 'casual_walking',
      category: 'walking',
      category_name: 'Walking',
    },
    speed_walking: {
      name: 'Speed Walking',
      garmin_id: 'speed_walking',
      category: 'walking',
      category_name: 'Walking',
    },
  },
  'Water Sports': {
    boating: {
      name: 'Boating',
      garmin_id: 'boating',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    canoeing: {
      name: 'Canoeing',
      garmin_id: 'canoeing',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    fishing: {
      name: 'Fishing',
      garmin_id: 'fishing',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    kayaking: {
      name: 'Kayaking',
      garmin_id: 'kayaking',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    kiteboarding: {
      name: 'Kiteboarding',
      garmin_id: 'kiteboarding',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    offshore_grinding: {
      name: 'Offshore Grinding',
      garmin_id: 'offshore_grinding',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    rowing: {
      name: 'Rowing',
      garmin_id: 'rowing',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    sailing: {
      name: 'Sailing',
      garmin_id: 'sailing',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    snorkeling: {
      name: 'Snorkeling',
      garmin_id: 'snorkeling',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    stand_up_paddleboarding: {
      name: 'Stand Up Paddleboarding',
      garmin_id: 'stand_up_paddleboarding',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    surfing: {
      name: 'Surfing',
      garmin_id: 'surfing',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    tubing: {
      name: 'Tubing',
      garmin_id: 'tubing',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    wakeboarding: {
      name: 'Wakeboarding',
      garmin_id: 'wakeboarding',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    wakesurfing: {
      name: 'Wakesurfing',
      garmin_id: 'wakesurfing',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    waterskiing: {
      name: 'Waterskiing',
      garmin_id: 'waterskiing',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    whitewater: {
      name: 'Whitewater',
      garmin_id: 'whitewater',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
    windsurfing: {
      name: 'Windsurfing',
      garmin_id: 'windsurfing',
      category: 'water_sports',
      category_name: 'Water Sports',
    },
  },
  'Winter Sports': {
    backcountry_skiing: {
      name: 'Backcountry Skiing',
      garmin_id: 'backcountry_skiing',
      category: 'winter_sports',
      category_name: 'Winter Sports',
    },
    'backcountry_skiing/snowboarding': {
      name: 'Backcountry Skiing/Snowboarding',
      garmin_id: 'backcountry_skiing/snowboarding',
      category: 'winter_sports',
      category_name: 'Winter Sports',
    },
    backcountry_snowboarding: {
      name: 'Backcountry Snowboarding',
      garmin_id: 'backcountry_snowboarding',
      category: 'winter_sports',
      category_name: 'Winter Sports',
    },
    cross_country_classic_skiing: {
      name: 'Cross Country Classic Skiing',
      garmin_id: 'cross_country_classic_skiing',
      category: 'winter_sports',
      category_name: 'Winter Sports',
    },
    cross_country_skate_skiing: {
      name: 'Cross Country Skate Skiing',
      garmin_id: 'cross_country_skate_skiing',
      category: 'winter_sports',
      category_name: 'Winter Sports',
    },
    resort_skiing: {
      name: 'Resort Skiing',
      garmin_id: 'resort_skiing',
      category: 'winter_sports',
      category_name: 'Winter Sports',
    },
    'resort_skiing/snowboarding': {
      name: 'Resort Skiing/Snowboarding',
      garmin_id: 'resort_skiing/snowboarding',
      category: 'winter_sports',
      category_name: 'Winter Sports',
    },
    resort_snowboarding: {
      name: 'Resort Snowboarding',
      garmin_id: 'resort_snowboarding',
      category: 'winter_sports',
      category_name: 'Winter Sports',
    },
    skating: {
      name: 'Skating',
      garmin_id: 'skating',
      category: 'winter_sports',
      category_name: 'Winter Sports',
    },
    snowmobiling: {
      name: 'Snowmobiling',
      garmin_id: 'snowmobiling',
      category: 'winter_sports',
      category_name: 'Winter Sports',
    },
    snowshoeing: {
      name: 'Snowshoeing',
      garmin_id: 'snowshoeing',
      category: 'winter_sports',
      category_name: 'Winter Sports',
    },
  },
  Driving: {
    car: {
      name: 'Car',
      garmin_id: 'car',
      category: 'driving',
      category_name: 'Driving',
    },
  },
  Aviation: {
    flight: {
      name: 'Flight',
      garmin_id: 'flight',
      category: 'aviation',
      category_name: 'Aviation',
    },
    plane: {
      name: 'Plane',
      garmin_id: 'plane',
      category: 'aviation',
      category_name: 'Aviation',
    },
  },
  Rail: {
    rail: {
      name: 'Rail',
      garmin_id: 'rail',
      category: 'rail',
      category_name: 'Rail',
    },
  },
} as const
